import React from "react";

import clsx from "clsx";

export const NavbarDivider = ({ className }: { className?: string }) => (
  <div className={clsx("h-6 w-[1.1px] bg-[#C1C5CD]", className)} />
);
